/** Inbox split column layout — aligned with aims-htl spacing tokens. */
export const INBOX_THREAD_WIDTH_PX = 500;
export const INBOX_COLUMN_GAP_CLASS = 'gap-8';

/**
 * Col 1 (list) is a resizable `react-resizable-panels` Panel (CT-5308) rather
 * than the fixed `INBOX_LIST_WIDTH_PX` it used to be. Sizes are percentages
 * of the split's total width. Max is capped at a third of the split so the
 * list can never crowd out the detail/thread columns.
 */
export const INBOX_LIST_DEFAULT_SIZE_PERCENT = 20;
export const INBOX_LIST_MIN_SIZE_PERCENT = 15;
export const INBOX_LIST_MAX_SIZE_PERCENT = 100 / 3;
